<ew-mat-dialog-custom>
  <ew-mat-stepper-custom
    [sendIn]="'last'"
    [validations]="validations"
    [textForSendButton]="data.proceedButton"
    [textForCloseButton]="data.cancelButton"
    [progressBar]="false"
    [useCloseButton]="true"
    (send)="send()">
    <ew-mat-stepper-custom-step
      classContainer="text-center overflow-hidden"
      [title]="data.title | translate">
      <main class="flex flex-col justify-between items-center">
        <treo-message
          class="text-left mt-10 w-full"
          [showIcon]="true"
          [showButtonClose]="false"
          [type]="'warn'"
          [appearance]="'outline'">
          <i treoMessageIcon class="fa-solid fa-triangle-exclamation"></i>
          <div class="flex flex-col font-medium">
            <span>{{ data.message | translate }}</span>
          </div>
        </treo-message>
      </main>

      <mat-checkbox
        [disableRipple]="true"
        [formControl]="confirmation"
        ngClass="mt-10">
        <span> {{ 'paymentsDeletion:checkboxText' | translate }}</span>
      </mat-checkbox>
    </ew-mat-stepper-custom-step>
  </ew-mat-stepper-custom>
</ew-mat-dialog-custom>
